export function locationTabs() {
	document.querySelectorAll('.location-link-list').forEach(list => {
		list.querySelectorAll('[data-location]').forEach(link => {
			link.addEventListener('click', () => {
				const target = link.dataset.location
				const section = link.closest('.teaser--locations')

				list.querySelectorAll('[data-location]').forEach(l => l.classList.remove('is-active'))
				section.querySelectorAll('.location-content').forEach(c => c.classList.add('is-hidden'))

				link.classList.add('is-active')
				section.querySelector(`.location-content[data-location="${target}"]`).classList.remove('is-hidden')
			})
		})
	})
}
